var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center mb-4"},[_c('h4',{staticClass:"fs-20 font-w600 mb-0 me-auto"}),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }